import React from 'react';
import {
  APP_VERSION,
  getDesktopInstallerFileName,
  getDesktopInstallerUrl,
  isElectronShell,
} from '../../utils/desktopDownload';
import './DownloadWindowsLink.css';

/**
 * Ungated public download. Hidden inside the desktop app — that user
 * already has an installer.
 */
const DownloadWindowsLink = ({ variant = 'default' }) => {
  if (isElectronShell()) return null;

  const extra =
    variant === 'primary' ? ' download-windows-link--primary' : '';
  const fileName = getDesktopInstallerFileName();

  return (
    <a
      className={`download-windows-link${extra}`}
      href={getDesktopInstallerUrl()}
      download={fileName}
      rel="noopener noreferrer"
    >
      Download Fokus {APP_VERSION} for Windows
    </a>
  );
}

export default DownloadWindowsLink;
